import React from 'react';
import { Alert } from './Alert';
import './AlertStack.scss';

// Component to map and stack all alert messages
export function AlertStack(props) {
    // Get props
    const { alerts, close } = props;

    return (
        <>
            <div id="alert-stack" className="alert-stack-div">
                {alerts.map((alert) =>
                    <Alert 
                        key={alert.id}
                        id={alert.id} 
                        type={alert.type} 
                        message={alert.message} 
                        close={close}
                        noClose={alert?.noClose}
                    />
                )}
            </div>
        </>
    );
}
